import $ from 'jquery';
import accounting from 'accounting';

export function discounted(): void {
  const discount = parseFloat($('body').data('customer-discount'));

  // obeying accounting.js parameter order: unit, precision, thousand(delimiter), decimal(separator), format
  type MoneyFormat = [string, number, string, string, string];
  const symbolMoneyFormatMap: Record<string, MoneyFormat> = {
    USD: ['$', 2, ',', '.', '%s%v'],
    GBP: ['£', 2, ',', '.', '%s%v'],
    AUD: ['$', 2, ',', '.', '%s%v'],
    CAD: ['$', 2, ',', '.', '%s%v'],
    CHF: ['CHF', 2, "'", '.', '%s %v'],
    RUB: ['руб.', 2, ' ', ',', '%v %s'],
    CNY: ['CN¥', 2, ',', '.', '%s %v'],
  };
  const defaultMoneyFormat: MoneyFormat = ['€', 2, '.', ',', '%v %s'];

  const currency = function (
    price: number,
    currencyIdentifier: string
  ): string {
    const formatMoneyParams =
      symbolMoneyFormatMap[currencyIdentifier] || defaultMoneyFormat;
    return accounting.formatMoney(price, ...formatMoneyParams);
  };

  if (discount > 0) {
    $('.discount').each(function (index, htmlElement): void {
      const element = $(htmlElement);
      const rawPrice = element.data('raw-price');
      const currencyIdentifier = element.data('currency-identifier');
      const discounted = (rawPrice * (100 - discount)) / 100;
      element.html(
        `<div class="reducedPrice-original">${currency(rawPrice, currencyIdentifier)}</div>${currency(discounted, currencyIdentifier)}`
      );
    });
  } else {
    $('.campaignDiscount').each(function (index, htmlElement): void {
      const element = $(htmlElement);
      const actualPrice = element.data('raw-price');
      const campaignOriginalPrice = element.data('campaign-original-price');
      const currencyIdentifier = element.data('currency-identifier');
      if (campaignOriginalPrice > actualPrice) {
        element.html(
          `<div class="reducedPrice-original">${currency(campaignOriginalPrice, currencyIdentifier)}</div>${currency(actualPrice, currencyIdentifier)}`
        );
      }
    });
  }
}

$(document).on('ready turbo:load turbo-frame:load', discounted);
